import { useTranslation } from 'react-i18next';
import React from 'react';
import RankBadge from '../elo/RankBadge';
import EloHistoryChart from '../elo/EloHistoryChart';

/**
 * ELO rank display section for player profile — badge, score, stats, form, history chart.
 */
export default function EloProfileSection({ eloData }) {
  const { t } = useTranslation();
  if (!eloData || !eloData.elo || !eloData.is_ranked) return null;

  return (
    <div className="elo-profile-section">
      <div className="elo-profile-header">
        <div className="elo-profile-rank">
          <RankBadge elo={eloData.elo} rank={eloData.rank} size="large" />
          <div className="elo-profile-score">
            <span className="elo-current">{eloData.elo}</span>
            <span className="elo-label">ELO</span>
          </div>
        </div>
        <div className="elo-profile-stats">
          <div className="elo-mini-stat">
            <span className="elo-mini-value">{eloData.peak_elo}</span>
            <span className="elo-mini-label">{t('elo.peak')}</span>
          </div>
          <div className="elo-mini-stat">
            <span className="elo-mini-value">
              <span className="elo-wins">{eloData.wins}</span>
              <span className="elo-wl-sep">/</span>
              <span className="elo-losses">{eloData.losses}</span>
            </span>
            <span className="elo-mini-label">V/F</span>
          </div>
          <div className="elo-mini-stat">
            <span className="elo-mini-value">{eloData.win_rate}%</span>
            <span className="elo-mini-label">{t('elo.winPct')}</span>
          </div>
          {eloData.position && (
            <div className="elo-mini-stat">
              <span className="elo-mini-value">#{eloData.position}</span>
              <span className="elo-mini-label">{t('elo.placement')}</span>
            </div>
          )}
          {eloData.best_streak >= 3 && (
            <div className="elo-mini-stat">
              <span className="elo-mini-value">{eloData.best_streak}V</span>
              <span className="elo-mini-label">{t('elo.bestStreak')}</span>
            </div>
          )}
        </div>
        {eloData.form && eloData.form.length > 0 && (
          <div className="elo-form-section">
            <span className="elo-form-label">{t('elo.form')}</span>
            <div className="form-bar">
              {eloData.form.map((won, i) => (
                <span key={i} className={`form-block ${won ? 'win' : 'loss'}`} />
              ))}
            </div>
            {eloData.current_streak >= 3 && (
              <span className="streak-badge hot">🔥 {eloData.current_streak}W streak</span>
            )}
            {eloData.current_streak <= -3 && (
              <span className="streak-badge cold">❄️ {Math.abs(eloData.current_streak)}L streak</span>
            )}
          </div>
        )}
      </div>
      {eloData.recent_changes && eloData.recent_changes.length > 0 && (
        <div className="elo-history">
          <h4>ELO-historik (senaste {eloData.recent_changes.length} matcher, enbart 5v5)</h4>
          <EloHistoryChart recentChanges={eloData.recent_changes} />
        </div>
      )}
    </div>
  );
}
